import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * EmptyState Component
 *
 * Displays empty state message when no templates are found.
 *
 * @param {Object} props
 * @param {string} props.searchQuery - Current search query
 * @param {string} props.categoryFilter - Current category filter
 */
function EmptyState({ searchQuery, categoryFilter }) {
  return (
    <Box textAlign="center" py={8}>
      <Typography variant="h6" color="text.secondary">
        No templates found
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {searchQuery || categoryFilter !== 'all'
          ? 'Try adjusting your search or filters'
          : 'Create your first template to get started'}
      </Typography>
    </Box>
  );
}

export default EmptyState;
